module.exports = function (left, right, options) {
  return left === right ? options.inverse(this) : options.fn(this);
};
